module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7.23d5dc49.png";